
const userName = localStorage.getItem('user');
const account = {
  displayName: userName,
  email: 'demo@minimals.cc',
  photoURL: '/assets/images/avatars/avatar_default.jpg',
};

export default account;
